/**
 * Returns the base URL for auth routes.
 * In Lovable preview/dev → same-origin (relative path).
 * In production → absolute URL to app subdomain.
 */
export function getAuthUrl(path: string = "/auth"): string {
  const isPreview = window.location.hostname.includes("lovable");
  const base = isPreview ? "" : "https://app.serento.ai";
  return `${base}${path}`;
}
